import React, {useState} from 'react';
import SideBgProjectItem from './SideBgProjectItem/SideBgProjectItem';
import {authPath, mainPath} from '../../../routes/paths';
import {NavLink, useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {setModal} from '../../../redux/actions/app/appActions';
import {ReactComponent as ProjectsIcon} from '../../../assets/icons/projects.svg';
import {ReactComponent as CompanyIcon} from '../../../assets/icons/company.svg';
import {ReactComponent as ProfileIcon} from '../../../assets/icons/profile.svg';
import {ReactComponent as SupportIcon} from '../../../assets/icons/support.svg';
import {ReactComponent as LogoutIcon} from '../../../assets/icons/logout.svg';
import {POPUPS} from '../../../redux/actions/app/appActionTypes';
import {logOut, tokenRevoke} from '../../../redux/actions/auth/authActions';
import {useTranslation} from 'react-i18next';
import {hasPermission} from '../../../helpers/functions';
import {PERMISSIONS} from '../../../helpers/constants';

const SideBgItems = () => {
  const [logoutClicked, setLogoutClicked] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const projectList = useSelector(({projects}) => projects.projects);
  const companyList = useSelector(({company}) => company.companies);
  const {t} = useTranslation();
  const {profileMe} = useSelector((state) => state.profile);

  const logout = async () => {
    if (logoutClicked) {
      return;
    }
    setLogoutClicked(true);
    await dispatch(tokenRevoke());
    setLogoutClicked(false);
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    history.push(authPath.signIn);
    dispatch(logOut());
  };

  const handleShowSupportPopup = () => {
    dispatch(setModal(POPUPS.SUPPORT_POPUP));
  };

  const permissionCompany = hasPermission(PERMISSIONS.COMPANY_READ, profileMe?.permissions ?? []);

  return (
    <div className={'side-bg__items'}>
      <div className='side-bg__projects'>
        <NavLink to={mainPath.projects}>
          <div className='side-bg__svg'>
            <ProjectsIcon />
          </div>
          <span>
            {t('SideBgItems.projects')}
            <div>{projectList.length > 0 ? `(${projectList.length})` : ''}</div>
          </span>
        </NavLink>
        <div className='side-bg__subItems'>
          {projectList?.map((item, index) => (
            <SideBgProjectItem
              id={item.id}
              hasNotification={item.hasNotification}
              key={index}
              address={item.address}
              count={item?.messageCount ?? 0}
            />
          ))}
        </div>
      </div>
      {permissionCompany && (
        <NavLink to={mainPath.companies} className={'side-bg__elem'}>
          <div className='side-bg__svg'>
            <CompanyIcon />
          </div>
          <span>
            {t('SideBgItems.companies')} <div>{companyList.length > 0 ? `(${companyList.length})` : ''}</div>
          </span>
        </NavLink>
      )}

      <NavLink to={mainPath.profile} className={'side-bg__elem'}>
        <ProfileIcon />
        <span>{t('SideBgItems.profile')}</span>
      </NavLink>
      <div onClick={handleShowSupportPopup} className={'side-bg__elem'}>
        <div className='side-bg__svg'>
          <SupportIcon />
        </div>
        <span>{t('SideBgItems.support')}</span>
      </div>
      <div onClick={logout} className={'side-bg__elem side-bg__logout'}>
        <div className='side-bg__svg'>
          <LogoutIcon />
        </div>
        <span>{t('SideBgItems.logout')}</span>
      </div>
    </div>
  );
};

export default SideBgItems;
